// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","970":"component---src-pages-about-tsx"}[chunkId] + "-" + {"223":"eb3935b83541008d12eb","245":"dd45e100eae8471951ab","453":"fd5808383fbd34ef619c","970":"f956e071eca667b18bb5"}[chunkId] + ".js";
};